export const getEmandates = payload => ({
  type: 'GET_EMANDATE',
  payload,
});

export const setEmandates = data => ({
  type: 'SET_EMANDATE',
  data,
});

export const getEmandateDetails = payload => ({
  type: 'GET_EMANDATE_DETAIS',
  payload,
});

export const setEmandateDetail = data => ({
  type: 'SET_EMANDATE_DETAIS',
  data,
});

export const getAuditTrails = payload => ({
  type: 'GET_AUDIT_TRAILS',
  payload,
});

export const setAuditTrails = data => ({
  type: 'SET_AUDIT_TRAILS',
  data,
});
